import { render, staticRenderFns } from "./AboutDescriptionsSection.vue?vue&type=template&id=171f1f89&scoped=true&"
import script from "./AboutDescriptionsSection.vue?vue&type=script&lang=js&"
export * from "./AboutDescriptionsSection.vue?vue&type=script&lang=js&"
import style0 from "./AboutDescriptionsSection.vue?vue&type=style&index=0&id=171f1f89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171f1f89",
  null
  
)

export default component.exports